export default {
	'delete-unit': 'حذف الواحدة',
	unit: 'واحدة'
}